export const filterActions = {
  TEACHER: 0,
  CENTRE: 1,
  SELECT_ALL_TEACHERS: 2,
  SELECT_ALL_CENTRES: 3,
  PREFILL_TEACHER_FILTER: 4,
  STAFF_APPLICATION_DISPLAY: 5,
  LESSON_RECORD_DISPLAY: 6,
  BIRTHDAYS_DISPLAY: 7,
};

export const filterReducer = (state, action) => {
  switch (action.type) {
    case filterActions.TEACHER:
      return {
        ...state,
        teacherFilter: {
          ...state.teacherFilter,
          [action.payload.teacherId]: {
            ...state.teacherFilter[action.payload.teacherId],
            show: action.payload.show,
          },
        },
      };
    case filterActions.CENTRE:
      return {
        ...state,
        centreFilter: {
          ...state.centreFilter,
          [action.payload.centre]: action.payload.show,
        },
      };
    case filterActions.SELECT_ALL_TEACHERS:
      return {
        ...state,
        teacherFilter: Object.fromEntries(
          Object.entries(state.teacherFilter).map(([teacherId, value]) => [
            teacherId,
            { ...value, show: action.payload },
          ]),
        ),
      };
    case filterActions.SELECT_ALL_CENTRES:
      return {
        ...state,
        centreFilter: Object.fromEntries(
          Object.entries(state.centreFilter).map(([centre]) => [
            centre,
            action.payload,
          ]),
        ),
      };
    case filterActions.PREFILL_TEACHER_FILTER:
      const teacherFilter = Object.fromEntries([
        ...action.payload?.map((teacher) => [
          teacher.value.id,
          {
            fullName: teacher.value.fullName,
            show: true,
          },
        ]),
        [
          "unassigned",
          {
            fullName: "Unassigned",
            show: true,
          },
        ],
      ]);
      return {
        ...state,
        teacherFilter,
      };
    case filterActions.STAFF_APPLICATION_DISPLAY:
      return {
        ...state,
        staffApplicationDisplay: action.payload,
      };
    case filterActions.LESSON_RECORD_DISPLAY:
      return {
        ...state,
        lessonRecordDisplay: action.payload,
      };
    case filterActions.BIRTHDAYS_DISPLAY:
      return {
        ...state,
        birthdaysDisplay: action.payload,
      };
    default:
      return state;
  }
};

export const newAttendanceModalActions = {
  OPEN: "open",
  HIDE: "hide",
};

export const newAttendanceModalReducer = (state, action) => {
  switch (action.type) {
    case newAttendanceModalActions.OPEN:
      return { ...state, show: true, lessonDetail: action.payload };
    case newAttendanceModalActions.HIDE:
      return { ...state, show: false, lessonDetail: {} };
    default:
      return state;
  }
};

export const initialNewAttendanceModalState = {
  show: false,
  lessonDetail: {},
};

export const initialAddHomeworkModalState = {
  show: false,
  lessonDetail: [],
};

export const addHomeworkModalActions = {
  OPEN: "open",
  HIDE: "hide",
};

export const addHomeworkModalReducer = (state, action) => {
  switch (action.type) {
    case addHomeworkModalActions.OPEN:
      return { ...state, show: true, lessonDetail: action.payload };
    case addHomeworkModalActions.HIDE:
      return { ...state, show: false, lessonDetail: [] };
    default:
      return state;
  }
};
